import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignSelf: "center",
    height: "auto",
    paddingHorizontal: 20,
    marginBottom: 30,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  contentBtn: {
    marginBottom: 40,
    marginTop: 20,
    paddingHorizontal: 25,
    width: 320,
    alignSelf: "center",
  },
  titularityText: {},

  cardTitle: {
    color: "#077A97",
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 20,
  },

  warningContainer: {
    marginTop: 20,
    marginBottom: 20,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 0.5,
    justifyContent: "center",
    borderColor: "#fff",
  },

  img: {
    tintColor: "#077A97",
    width: 24,
    height: 24,
    marginRight: 6,
  },

  inputBank: {
    minWidth: 320,
  },

  label: {
    fontWeight: 600,
  },

  btn: {
    width: 320,
    alignSelf: "center",
    padding: 10,
    borderRadius: 4,
    backgroundColor: "#077A97",
    color: "#fff",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
});

export default styles;
